module.exports = __webpack_public_path__ + "static/image/together/pc/visual.jpg?3dd81e34";